import { Box, useTheme, Typography } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import profile_banner from "../../Assets/images/Profile/profile_banner.webp";
import { useTranslation } from "react-i18next";

const BannerImageForTruckDetails = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        position: "relative",
        height: { xs: "200px", sm: "300px", md: "50vh", lg: "40vh" },
        // width: "100%",
      }}
    >
      <Box sx={{ height: "100%" }}>
        <img
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            filter: "blur(2px)",
            WebkitFilter: "blur(2px)",
          }}
          src={profile_banner}
          alt="preview"
        />{" "}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            bgcolor: "rgba(0, 0, 0, 0.5)",
            borderRadius: "inherit",
          }}
        />
      </Box>
      <Box
        sx={{
          color: theme.palette.text.defaultLight,
          position: "absolute",
          zIndex: 1,
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          fontSize: { xs: "24px", lg: "34px", md: "48px" },
          width: { xs: "100%", md: "60%", lg: "50%" },
        }}
      >
        <Typography
          sx={{
            color: theme.palette.text.defaultLight,
            fontSize: { xs: "20px", sm: "24px", lg: "34px", md: "48px" },
            textAlign: "center",
            textTransform: "uppercase",
          }}
          className="fontSnugle"
        >
          {t("explore.fiestaCatering")}
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            justifyContent: "center",
            width: "100%",
          }}
        >
          <Typography
            sx={{
              textAlign: "center",
              color: theme.palette.text.defaultLight,
              fontSize: { xs: "14px", sm: "16px", lg: "22px", md: "28px" },
            }}
          >
            {t("explore.home")}
          </Typography>
          <ArrowForwardIcon sx={{ color: theme.palette.text.defaultLight }} />{" "}
          <Typography
            sx={{
              textAlign: "center",
              color: theme.palette.text.defaultLight,
              fontSize: { xs: "14px", sm: "16px", lg: "22px", md: "28px" },
            }}
          >
            {t("explore.foodtruck")}
          </Typography>
          <ArrowForwardIcon sx={{ color: theme.palette.text.defaultLight }} />{" "}
          <Typography
            sx={{
              textAlign: "center",
              color: theme.palette.text.defaultLight,
              fontSize: { xs: "14px", sm: "16px", lg: "22px", md: "28px" },
            }}
          >
            {t("explore.foodtruckdetails")}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default BannerImageForTruckDetails;
